import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

export type CheckSdkConnectionEventInfo = {
  component?: string;
};

const trackCheckSdkConnectionEvent = (event: string, attributes?: CheckSdkConnectionEventInfo) =>
  createTrackerForCategory('Check SDK Connection')(event, attributes);

export const trackSetUpSDKButtonClicked = (component?: string) =>
  trackCheckSdkConnectionEvent('Set Up SDK Button Clicked', { component });
